import React from 'react'
import { motion } from 'framer-motion'
import { Field } from './'


const FieldWithCredit = ({ children, className="", credit, sanSerif,  active, bold }) => {
	const opacity = active ? 1 : 0
	return (
		<div className='field-with-credit'>
			<Field bold={bold} className={className} sanSerif={sanSerif}>{children}</Field>
			<motion.div
				className="credit"
				initial={{ opacity: 0 }}
				animate={{ opacity }}
			>
				{credit}
			</motion.div>
			<style jsx>{`
				div {
					height: 100%;
					max-height: 100px;
					display: flex;
					justify-content: space-between;
					flex-direction: column;
				}

				:global(.credit) {
					font-family: 'Graphik';
					font-size: 14px;
					margin-top: 1.25rem;			
				}

				@media (max-width: 769px), (pointer: coarse) {
					div {
						height: auto;
						display: block;
						max-height: none;
					}

					.field-with-credit :global(.credit){ 
						display: none;
					}
				}
			`}</style>
		</div>
	)
}

export default FieldWithCredit
